export default "__VITE_ASSET__aiWVtr9w__"